function useDealerId() {
    const dlid = localStorage.getItem("_dlid");
    return dlid;
}

export default useDealerId;
